import React from 'react';
import { AppStatus, Language } from '../types';
import { UI_STRINGS } from '../constants';

interface StatusIndicatorProps {
  status: AppStatus;
  language: Language;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status, language }) => {
  const strings = UI_STRINGS[language];

  if (status === AppStatus.IDLE || status === AppStatus.ERROR) return null;

  return (
    <div className="fixed top-16 sm:top-24 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 animate-in fade-in slide-in-from-top-4">
      <div className="bg-slate-900/80 backdrop-blur-xl border border-white/10 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.5)] px-4 sm:px-6 py-2 sm:py-3 rounded-xl sm:rounded-2xl flex items-center space-x-3 sm:space-x-4 whitespace-nowrap">
        {status === AppStatus.LISTENING && (
          <>
            <div className="flex space-x-1 sm:space-x-1.5 items-center">
              <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-cyan-400 rounded-full animate-ping"></div>
              <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-cyan-400 rounded-full animate-ping [animation-delay:0.2s]"></div>
              <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-cyan-400 rounded-full animate-ping [animation-delay:0.4s]"></div>
            </div>
            <span className="text-[10px] sm:text-xs font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] text-cyan-400">{strings.listening}</span>
          </>
        )}
        {status === AppStatus.PROCESSING && (
          <>
            <svg className="animate-spin h-4 w-4 sm:h-5 sm:w-5 text-cyan-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-100" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-[10px] sm:text-xs font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] text-slate-300">{strings.processing}</span>
          </>
        )}
        {status === AppStatus.SPEAKING && (
          <>
            <div className="flex items-center space-x-1 h-3 sm:h-4">
              <div className="w-0.5 sm:w-1 h-2 bg-cyan-400 animate-[pulse_0.8s_infinite]"></div>
              <div className="w-0.5 sm:w-1 h-4 bg-cyan-400 animate-[pulse_1s_infinite]"></div>
              <div className="w-0.5 sm:w-1 h-3 bg-cyan-400 animate-[pulse_1.2s_infinite]"></div>
              <div className="w-0.5 sm:w-1 h-5 bg-cyan-400 animate-[pulse_0.9s_infinite]"></div>
            </div>
            <span className="text-[10px] sm:text-xs font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] text-cyan-400">{strings.speaking}</span>
          </>
        )}
      </div>
    </div>
  );
};
